export default __webpack_public_path__ + "static/media/AneomiOpen5.ccee9c8e.jpg";